import { atom } from "jotai";
import { User } from "../types";

// Create your atoms and derivatives
export const userAtom = atom<undefined | User>(undefined);
export const hasCheckLoginAtom = atom<boolean>(false);
